<template>
    <div>
        <b-modal title="Save Search" id="save-search-popup" modal-class="modal-w-lg">

            <form class="form form-modal">
                <div class="form__item mb-4">
                    <label class="form__label">Search Name</label>
                    <input v-model="name" class="form-control form-control--mid">
                </div>

                <div class="form__item">
                    <label class="form__label">Privacy</label>

                    <div class="input-radio mb-3">
                        <input id="pr1" type="radio" v-model="type" value="personal">
                        <label for="pr1">Only me</label>
                    </div>
                    <div class="input-radio">
                        <input id="pr2" type="radio" v-model="type" value="company">
                        <label for="pr2">Shared with company</label>
                    </div>
                </div>

                <div class="form__item" v-if="searchType === searchTypes.STARTUPS && $store.getters.isEnterprise">
                    <div class="auto-scout">
                        <h5 class="auto-scout__title">Auto-Scout</h5>
                    
                        <p class="modal-text">Enabling auto-scout automatically adds startups that match your search criteria to the trackers of your choice.</p>
                    </div>
                    <div>
                        <div class="input-checkbox">
                            <input id="auto-scouting" type="checkbox" v-model="auto_scout">
                            <label for="auto-scouting">Enable Auto-Scout</label>
                        </div>
                    </div>
                </div>

                <div class="form__item row">

                    <div class="col-md-8">

                        <template v-if="auto_scout">
                            <label class="form__label">Add New Matches To Tracker:</label>
                            <multiselect
                                v-model="trackers"
                                :options="trackersList"
                                :multiple="true"
                                select-label=""
                                deselect-label=""
                                placeholder="Type to search your trackers"
                                label="name"
                                track-by="name"
                                class="multiselect-mid selectbox selectbox-mid mb-3"
                            >
                            </multiselect>
                        </template>
                    </div>

                    <div class="col-md-4" v-if="auto_scout && stagesList.length">
                        <label class="form__label">Add To Stage:</label>
                        <multiselect
                            v-model="stage"
                            :options="stagesList"
                            select-label=""
                            deselect-label=""
                            label="name"
                            track-by="name"
                            class="multiselect-mid selectbox selectbox-mid mb-3"
                        >
                        </multiselect>
                    </div>
                </div>
            </form>

            <template #modal-footer>
                <b-button :disabled="!name.length" variant="primary" size="lg" @click="save">Save</b-button>
            </template>
        </b-modal>

        <b-modal title="Manage Saved Searches" id="manage-saved-searches-popup" size="md" ok-only ok-variant="secondary" ok-title="Close" hide-footer>

            <div v-for="(group, groupName) in list" :key="groupName">
                <h5 class="heading5 heading5--secondary">{{groupName}}</h5>

                <ul class="manage-list">
                    <li v-for="(item, index) in group" :key="index">
                        <p class="manage-list__title">{{list[groupName][index].name}}</p>

                        <a class="manage-list__status" v-if="searchType === searchTypes.STARTUPS && $store.getters.isEnterprise" :class="{'manage-list__active': item.auto_scout}" @click="setAutoScout(item)">Auto-Scout</a>
                        
                        <div class="manage-list__controls">
                            <a @click="openSave(item.id)" class="link-edit">Edit</a>
                            <a @click="deleteSearch(item.id)" class="link-remove">Delete</a>
                        </div>
                    </li>
                </ul>
            </div>
        </b-modal>

        <b-modal id="save-search-popup-trackers" title="Before You Enable Auto-Scout...">
            <p>Startup questions and auto-scout can't be turned on at the same time. Disable startup questions by editing this tracker in order to
                turn on Auto-Scout</p>

            <template #modal-footer>
                <b-button variant="primary" size="lg" @click="$bvModal.hide('save-search-popup-trackers')">Okay</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>

import savedSearches from '@/services/saved-searches.service'
import trackers from '@/services/trackers.service'
import multiselect from "vue-multiselect";
import searchTypes from "@/constants/searchTypes";

export default {
    computed: {
        searchTypes() {
            return searchTypes
        }
    },

    props: {
        rules: Array,
        savedSearchesList: Array,
        searchType: String,
    },

    components: {
        multiselect
    },

    data() {
        return {
            id: 0,
            name: '',
            type: 'personal',
            tracker_ids: [],
            stage_id: null,
            stage: null,
            auto_scout: false,

            trackers: [],

            trackersList: [],
            stagesList: [],

            list: {},

            notWatchTrackers: false,
        }
    },

    watch: {
        savedSearchesList() {
            let list = {}

            this.savedSearchesList.forEach(group => {
                list[group.group] = []

                group.items.forEach((item) => {
                    list[group.group].push({
                        id: item.id,
                        name: item.name,
                        newName: item.name,
                        auto_scout: item.auto_scout,
                        has_tackers: item.has_tackers,
                        editMode: false,
                    })
                })
            })

            this.list = list
        },

        auto_scout() {
            if (!this.auto_scout) {
                this.trackers = []
            }
        },

        trackers() {
            if (!this.notWatchTrackers) {
                for (let i in this.trackers) {
                    if (this.trackers[i].has_questions) {
                        this.trackers.splice(i, 1)

                        this.$bvModal.show('save-search-popup-trackers')
                    }
                }

                this.tracker_ids = this.arrayHelper.arrayColumn(this.trackers, 'value')
                this.getStages()
            }
        },

        stage() {
            if (this.stage) {
                this.stage_id = this.stage.id
            }
            else {
                this.stage_id = null
            }
        }
    },

    mounted() {
        if (this.$store.getters.isEnterprise) {
            this.getTrackers()
        }
    },

    methods: {
        openSave(id = 0) {
            this.id = 0
            this.name = ''
            this.type = 'personal'
            this.tracker_ids = []
            this.trackers = []
            this.stage_id = null
            this.stage = null
            this.auto_scout = false

            if (id) {
                savedSearches.getEdit(id).then(response => {
                    this.id = id
                    this.name = response.data.name
                    this.type = response.data.type
                    this.tracker_ids = response.data.tracker_ids
                    this.auto_scout = response.data.auto_scout

                    this.notWatchTrackers = true

                    response.data.tracker_ids.forEach(item => {
                        let index = this.arrayHelper.findIndexByColumnValue(this.trackersList, 'value', item)
                        if (index >= 0) {
                            this.trackers.push(this.trackersList[index])
                        }
                    })

                    this.notWatchTrackers = false

                    if (response.data.stage_id) {
                        this.stage_id = response.data.stage_id
                    }

                    this.getStages()

                    this.$bvModal.show('save-search-popup')
                })
            }
            else {
                this.$bvModal.show('save-search-popup')
            }
        },

        save() {
            let data = {
                name: this.name,
                search_type: this.searchType,
                type: this.type,
                rules: this.rules,
                trackers: this.tracker_ids,
                stage: this.stage_id,
                auto_scout: this.auto_scout,
            }

            savedSearches.save(this.id, data).then(() => {
                this.$bvModal.hide('save-search-popup')
                this.$emit('saved-search-changed')
            })
        },

        setAutoScout(item) {
            savedSearches.setAutoScout(item.id, {auto_scout: !item.auto_scout}).then(() => {
                this.$emit('saved-search-changed')

                if (!item.auto_scout && !item.has_tackers) {
                    this.openSave(item.id)
                }
            })
        },

        getTrackers() {
            trackers.getListForSavedSearch().then(response => {
                this.trackersList = response.data
            })
        },

        getStages() {
            trackers.getTrackersStages(this.tracker_ids).then(response => {
                this.stagesList = response.data
                if (!this.stagesList.length) {
                    this.stage = null
                } else if (this.stage_id) {
                    let index = this.arrayHelper.findIndexByColumnValue(this.stagesList, 'value', this.stage_id)

                    if (index >= 0) {
                        this.stage = this.stagesList[index]
                    }
                }
            })
        },

        openManage() {
            this.$bvModal.show('manage-saved-searches-popup')
        },

        updateQuery(id) {
            savedSearches.updateQuery(id, this.rules).then(() => {
                this.$emit('saved-search-changed')
            })
        },

        deleteSearch(id) {
            if (confirm("Delete Search?")) {
                savedSearches.deleteSearch(id).then(() => {
                    this.$emit('saved-search-changed')
                })
            }
        }
    }
}
</script>
